import React from 'react';

// SmartPallet Logo - uses the brand image assets

export const LogoIcon = ({ size = 40, className = '' }) => (
  <img 
    src="/favicon.png" 
    alt="SmartPallet" 
    width={size} 
    height={size} 
    className={`rounded-lg ${className}`}
    style={{ objectFit: 'contain' }}
  />
);

// Full logo with text (for light backgrounds like nav bar)
export const Logo = ({ size = 'default', showText = true, className = '' }) => {
  const iconSizes = { small: 32, default: 40, large: 56 };
  const textSizes = { small: 'text-lg', default: 'text-xl', large: 'text-2xl' };
  const iconSize = iconSizes[size] || iconSizes.default;
  const textSize = textSizes[size] || textSizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoIcon size={iconSize} />
      {showText && (
        <div className="flex flex-col">
          <span className={`${textSize} font-bold text-slate-900`}>
            SmartPallet
          </span>
          {size !== 'small' && (
            <span className="text-xs text-slate-500">IoT Asset Tracking</span>
          )}
        </div>
      )}
    </div>
  );
};

// White version for dark backgrounds
export const LogoWhite = ({ size = 'default', showText = true, className = '' }) => {
  const iconSizes = { small: 32, default: 40, large: 56 };
  const textSizes = { small: 'text-lg', default: 'text-xl', large: 'text-2xl' };
  const iconSize = iconSizes[size] || iconSizes.default;
  const textSize = textSizes[size] || textSizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoIcon size={iconSize} />
      {showText && (
        <div className="flex flex-col">
          <span className={`${textSize} font-bold text-white`}>
            SmartPallet
          </span>
          {size !== 'small' && (
            <span className="text-xs text-white/70">IoT Asset Tracking</span>
          )}
        </div>
      )}
    </div>
  );
};

export const LogoMini = ({ size = 32, className = '' }) => (
  <LogoIcon size={size} className={className} />
);

export default Logo;
